import clsx from "clsx";
import React from "react";
import { useTheme } from "../../hooks";
import { IconHolder, IconStyled } from "./IconStyles";
const Icon = ({ iconName, iconCategory = "fas", className, onClick, disabled = false, styles = {}, ...rest }) => {
    const { Theme } = useTheme();
    const DefaultStyle = {
        color: Theme.icon["color"],
        size: Theme.icon["size"],
        hoverColor: Theme.icon["hoverColor"],
        disabledColor: Theme.icon["disabledColor"],
        padding: 0,
    };
    const classes = clsx("best-icon", iconCategory, iconName, className);
    const CompStyles = { ...DefaultStyle, ...styles };
    return (React.createElement(IconHolder, { styles: CompStyles, onClick: !disabled ? onClick : undefined },
        React.createElement(IconStyled, { className: classes, disabled: disabled, styles: CompStyles, ...rest })));
};
export default Icon;
//# sourceMappingURL=Icon.js.map